import Phaser from 'phaser';

const BG_OUTER = 0x0a0f1f;
const BG_INNER = 0x1f1014;
const BLADE = 0xfde047;
const BLADE_EDGE = 0xfbbf24;
const HANDLE = 0xef4444;
const STROKE = 0xffffff;

export function drawPowerSword(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const bladeLen = r * 1.4;
  const bladeW = r * 0.22;

  const cos = Math.cos(-Math.PI / 4);
  const sin = Math.sin(-Math.PI / 4);
  const points: { x: number; y: number }[] = [];
  const pts = [
    { x: -bladeLen / 2, y: -bladeW / 2 },
    { x: bladeLen / 2 - bladeW, y: -bladeW / 2 },
    { x: bladeLen / 2, y: 0 },
    { x: bladeLen / 2 - bladeW, y: bladeW / 2 },
    { x: -bladeLen / 2, y: bladeW / 2 },
  ];
  for (const p of pts) {
    points.push({ x: p.x * cos - p.y * sin, y: p.x * sin + p.y * cos });
  }

  g.fillStyle(BLADE, 1);
  g.beginPath();
  g.moveTo(points[0].x, points[0].y);
  for (let i = 1; i < points.length; i++) g.lineTo(points[i].x, points[i].y);
  g.closePath();
  g.fillPath();

  g.lineStyle(2, BLADE_EDGE, 1);
  g.strokePath();

  const hiltLen = r * 0.5;
  const hiltW = r * 0.12;
  const hiltPts: { x: number; y: number }[] = [];
  const hpts = [
    { x: -bladeLen / 2 - hiltLen, y: -hiltW / 2 },
    { x: -bladeLen / 2, y: -hiltW / 2 },
    { x: -bladeLen / 2, y: hiltW / 2 },
    { x: -bladeLen / 2 - hiltLen, y: hiltW / 2 },
  ];
  for (const p of hpts) {
    hiltPts.push({ x: p.x * cos - p.y * sin, y: p.x * sin + p.y * cos });
  }
  g.fillStyle(HANDLE, 1);
  g.beginPath();
  g.moveTo(hiltPts[0].x, hiltPts[0].y);
  for (let i = 1; i < hiltPts.length; i++) g.lineTo(hiltPts[i].x, hiltPts[i].y);
  g.closePath();
  g.fillPath();
  g.lineStyle(2, 0x7f1d1d, 1);
  g.strokePath();

  const crossLen = r * 0.45;
  const crossW = r * 0.1;
  const cpts = [
    { x: -bladeLen / 2 - crossW / 2, y: -crossLen / 2 },
    { x: -bladeLen / 2 + crossW / 2, y: -crossLen / 2 },
    { x: -bladeLen / 2 + crossW / 2, y: crossLen / 2 },
    { x: -bladeLen / 2 - crossW / 2, y: crossLen / 2 },
  ];
  const crossPts: { x: number; y: number }[] = [];
  for (const p of cpts) {
    crossPts.push({ x: p.x * cos - p.y * sin, y: p.x * sin + p.y * cos });
  }
  g.fillStyle(0xfde047, 1);
  g.beginPath();
  g.moveTo(crossPts[0].x, crossPts[0].y);
  for (let i = 1; i < crossPts.length; i++) g.lineTo(crossPts[i].x, crossPts[i].y);
  g.closePath();
  g.fillPath();
  g.lineStyle(2, 0x0a0f1f, 1);
  g.strokePath();
}
